import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import "../Assets/bootstrap/dist/css/bootstrap.min.css";
import "react-datetime/css/react-datetime.css";
import { HashRouter, Route, Switch } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Components
import MainLayoutContainer from "../MainLayout/MainLayoutContainer";
import LoginContainer from "../Login/LoginContainer";
import ChangePasswordContainer from "../ChangePassword/ChangePasswordContainer";
import UserListContainer from "../UserList/UserListContainer";
import DashboardContainer from "../Dashboard/DashboardContainer";
import AddOrUpdateUserContainer from "../AddOrUpdateUser/AddOrUpdateUserContainer";
import LoanDetailsContainer from "../LoanDetails/LoanDetailsContainer";
import { initializeInterceptors } from "../config/AxiosInterceptor";
import { logoutAction } from "../Login/LoginAction";

import AuditTrailContainer from "../AuditTrail/AuditTrailContainer";

// Import Application Configurations
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

//Actions
import { setSearchFilterAction } from "../redux/Action";

//Constants
import { URL_FILTER } from "../Utils/Constants";

//Styles
import "./App.scss";

//Strings
import { ChangeLanguage } from "../Translations/i18n";

class App extends Component {
  constructor(props) {
    super(props);
    if (window.performance) {
      if (
        window.performance &&
        window.performance.getEntriesByType("navigation") &&
        window.performance.getEntriesByType("navigation")[0] &&
        window.performance.getEntriesByType("navigation")[0].type === "reload"
      ) {
        let url = window.location.hash.replace("#", "");
        if (Object.keys(URL_FILTER).includes(url)) {
          this.props.setSearchFilterAction(
            URL_FILTER[url].key,
            URL_FILTER[url].filter
          );
        }
      }
    }
    initializeInterceptors(props.history, this.logoutAction);
  }
  logoutAction = (callback) => {
    this.props.logoutAction(callback);
  };
  componentDidMount() {
    ChangeLanguage(APPLICATION_CONFIGURATIONS.applicationLanguage);
  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route
            exact
            path={APPLICATION_CONFIGURATIONS.path.login}
            component={LoginContainer}
          />
          <MainLayoutContainer>
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.changePassword}
              component={ChangePasswordContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.userList}
              component={UserListContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.dashboard}
              component={DashboardContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.dashboardAppresta}
              component={DashboardContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.loanPortfolio}
              component={() => <DashboardContainer LOAN_PORTFOLIO={true} />}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.userDetails}
              component={AddOrUpdateUserContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.profileDetails}
              component={AddOrUpdateUserContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.loanDetails}
              component={LoanDetailsContainer}
            />
            <Route
              exact
              path={APPLICATION_CONFIGURATIONS.path.auditTrail}
              component={AuditTrailContainer}
            />
          </MainLayoutContainer>
        </Switch>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => ({}); //NOSONAR
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ logoutAction, setSearchFilterAction }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
